import React, { useContext } from "react";
import { Checkbox, Form, Input, InputNumber, Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { ThemeContext } from "../../../../../../../contexts/ThemeContext";
import { formatCurrencyInput } from "../../../../../../../utils/Masks";

interface IProps {
    label: string;
    tooltip?: string;
    unlimitedLabel?: string;
    isUnlimited?: boolean;
    onUnlimitedChange: (checked: boolean) => void;
    value: any;
    onChange: (val: any) => void;
    disabled?: boolean;
    error?: { message?: string };
    type?: "currency" | "number";
    addonAfter?: string;
    addonBefore?: string;
    placeholder?: string;
    min?: number;
}

export default function ConfigUnlimitedField({
    label,
    tooltip,
    unlimitedLabel = "Sem valor máximo",
    isUnlimited = false,
    onUnlimitedChange,
    value,
    onChange,
    disabled = false,
    error,
    type = "currency",
    addonAfter,
    addonBefore = "R$",
    placeholder,
    min = 0,
}: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    return (
        <div style={{ width: "100%" }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 6,
                    gap: 8,
                    minHeight: 22,
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                    <Typography.Text strong style={{ fontSize: 12.5, color: isDark ? "#f0f0f0" : "#334155" }}>
                        {label}
                    </Typography.Text>
                    {tooltip && (
                        <Tooltip title={tooltip}>
                            <InfoCircleOutlined style={{ color: "#94a3b8", fontSize: 12, cursor: "pointer" }} />
                        </Tooltip>
                    )}
                </div>
                <Checkbox
                    checked={isUnlimited}
                    onChange={(e) => onUnlimitedChange(e.target.checked)}
                    disabled={disabled}
                    style={{
                        fontSize: 11.5,
                        color: isDark ? "#94a3b8" : "#64748b",
                        userSelect: "none",
                        whiteSpace: "nowrap",
                    }}
                >
                    {unlimitedLabel}
                </Checkbox>
            </div>
            <Form.Item
                style={{ marginBottom: 0 }}
                validateStatus={error ? "error" : undefined}
                help={error?.message}
            >
                {type === "currency" ? (
                    <Input
                        value={isUnlimited ? "" : value}
                        onChange={(e) => onChange(formatCurrencyInput(e.target.value))}
                        addonBefore={addonBefore}
                        placeholder={isUnlimited ? unlimitedLabel : (placeholder || "0,00")}
                        disabled={isUnlimited || disabled}
                        style={{ width: "100%" }}
                    />
                ) : (
                    <InputNumber
                        value={isUnlimited ? undefined : value}
                        onChange={onChange}
                        placeholder={isUnlimited ? unlimitedLabel : (placeholder || "0")}
                        disabled={isUnlimited || disabled}
                        addonAfter={addonAfter}
                        min={min}
                        style={{ width: "100%" }}
                    />
                )}
            </Form.Item>
        </div>
    );
}
